import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import fc from '@/firebaseConfig'
import './assets/app.css'

import VueApollo from "vue-apollo";
import ApolloClient from "apollo-client";
import {createHttpLink} from 'apollo-link-http'
import {InMemoryCache} from "apollo-cache-inmemory";
import {setContext} from 'apollo-link-context';
import firebase from "firebase";

import Loading from "./components/public/loading"
import { formatCurrency } from './libs/helpers'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/th'
import locale from 'element-ui/lib/locale'
// configure language
locale.use(lang)

Vue.use(ElementUI);
Vue.use(VueApollo);
Vue.config.productionTip = false

Vue.prototype.$formatCurrency = formatCurrency

// const debug = process.env.NODE_ENV !== 'production'

// new Vue({
//   router,
//   store,
//   vuetify,
//   render: h => h(App)
// }).$mount('#app')

// HTTP connection to the API
const httpLink = createHttpLink({
  // You should use an absolute URL here
  uri: fc.graphqlUrl,
})

// Cache implementation
const cache = new InMemoryCache()

// Set JWT Token
const authLink = setContext(async (_, {headers}) => {
  // get the authentication token from local storage if it exists
  // let token = await firebase.auth().currentUser.getIdToken(/* forceRefresh */ true)
  let token = await firebase.auth().currentUser.getIdToken(false)
    .then(function (idToken) {
      return idToken
    })

  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `JWT ${token}` : "",
    }
  }
})

// Create the apollo client
const apolloClient = new ApolloClient({
  // link: httpLink,
  link: authLink.concat(httpLink),
  cache,
})

const apolloProvider = new VueApollo({
  defaultClient: apolloClient,
})

let app
fc.auth.onAuthStateChanged(() => {
  // console.log('onAuthStateChanged user:', user)
  if (!app) {
    app = new Vue({
      created() {
        window.fbAsyncInit = function () {
          window.FB.init({
            appId: '405232067262977',
            autoLogAppEvents: true,
            xfbml: true,
            version: 'v2.11'
          });
        };
        (function (d, s, id) {
          let js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return;
          js = d.createElement(s);
          js.id = id;
          js.src = "https://connect.facebook.net/en_US/sdk/xfbml.customerchat.js";
          fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'))
      },
      router,
      apolloProvider,
      store,
      vuetify,
      Loading,
      render: h => h(App)
    }).$mount('#app')
  }
})
